/**
 * D196/D251: the authored act a command names — one shape for a thing and a
 * body.
 *
 * @remarks
 * Its own module so the two narrowing steps that build it — a thing's
 * (`narrow-verb-answers.ts`) and a body's (`narrow-actor-aimed.ts`) — share
 * it without either importing the other for it.
 *
 * @packageDocumentation
 */

import type { ParsedCommand } from '@orpheus/parser-engine';

import type { ActedOn, RuntimeAction } from './runtime-action.js';

import { commandInHandOf } from '../conditions/command-in-hand.js';

/**
 * The act: the verb, what it is done to, and (D229) the sentence's other two
 * slots when they named a thing, so the arms are chosen with the sentence in
 * hand.
 *
 * @param command - The parsed proposal
 * @param verbToken - The canonical verb
 * @param actedOn - The thing or the body the act is done to
 * @returns The `act` action
 */
export const authoredActOf = (command: ParsedCommand, verbToken: string, actedOn: ActedOn): Extract<RuntimeAction, { type: 'act' }> => {
	const { indirectObjectItemId, toolItemId } = commandInHandOf(command);

	return {
		...actedOn,
		...(indirectObjectItemId === undefined ? {} : { indirectObjectItemId }),
		...(toolItemId === undefined ? {} : { toolItemId }),
		type: 'act',
		verbToken,
	};
};
